import {useEffect, useState} from "react";
import {Table, Divider} from "antd";
import {EyeOutlined, EyeInvisibleOutlined, TagOutlined} from '@ant-design/icons';
import {CONSTANTS} from "../utils/constant";
import {NESTED_COLS} from "../utils/colsMap"
import Strikedicon from "./icon/strikedicon";

export default function InteractionInnerTable({interactionType, record, onNestedRowClick, allInteraction, tagAllInteraction, selectedInteraction, pdb, folder}) {

    const [data, setData] = useState([]);
    const [nestedCol, setNestedCol] = useState([]);
    const [selectedKey, setSelectedKey] = useState();
    const [toggleInteractionStatus, setToggleInteractionStatus] = useState(false);
    const [toggleInteractionTag, setToggleInteractionTag] = useState(false);


    useEffect(() => {
        const callService = async () => {

            const postData = new FormData();
            postData.append("folder", folder);
            postData.append("pdb", pdb);
            postData.append("interactionType", interactionType);
            postData.append("chain1", record[3]);
            postData.append("chain2", record[6]);
            postData.append("chain1Idx", record[2]);
            postData.append("chain2Idx", record[5]);

            try {
                const response = await fetch(CONSTANTS.PHP_SCRIPT_BASE_PATH + 'get_details.php', {
                    method: 'POST',
                    body: postData
                });

                const result = await response.json();
                const keyData = result.data.map(row => {
                    return {
                        ...row,
                        key: row[2] + '_' + row[4] + '_' + row[6] + '_' + row[8]
                    }
                });
                setData(keyData);
                setNestedCol(getNestedCol(interactionType));

            } catch (error) {
                console.error('Errore durante la richiesta:', error);
            }
        };

        callService();
    }, [interactionType])

    const getNestedCol = (interactionType) => {
        return NESTED_COLS[interactionType];
    }

    useEffect(() => {
        if (selectedInteraction) {
            const key = selectedInteraction.residue1 + '_' + selectedInteraction.atom1
                + '_' + selectedInteraction.residue2 + '_' + selectedInteraction.atom2;
            setSelectedKey(key);
        }
    }, [selectedInteraction]);

    const toggleAllInteraction = () => {
        setToggleInteractionStatus(status => !status);
        allInteraction(interactionType, data, !toggleInteractionStatus);
    };

    const innerTagAllInteraction = () => {
        setToggleInteractionTag(status => !status);
        tagAllInteraction(interactionType, data, !toggleInteractionTag);
    };

    const rowClassName = (record) => {
        return record.key === selectedKey ? 'highlight' : '';
    };

    const onRow = (row) => {
        return {
            onClick: (e) => {
                onNestedRowClick(row, interactionType);
            }
        }
    };

    return (
        <>
            <Divider>{interactionType}
                <span onClick={toggleAllInteraction} style={{paddingLeft: '10px', paddingRight: '10px', cursor: 'pointer'}}>
                    {toggleInteractionStatus ? <EyeInvisibleOutlined/> : <EyeOutlined/>}
                </span>
                <span onClick={innerTagAllInteraction} style={{cursor: 'pointer'}}>
                    {toggleInteractionTag ? <Strikedicon icon={<TagOutlined/>}/> : <TagOutlined/>}
                </span>
            </Divider>
            <Table columns={nestedCol} dataSource={data} pagination={false} onRow={onRow} rowClassName={rowClassName}/>
        </>
    )
}